module.exports = __webpack_public_path__ + "img/child2.e5024066.png";